import React, { ForwardedRef, forwardRef } from "react";
import cn from "classnames";
import { NoBlueprintsFoundTableEmptyRow } from "@src/components/atoms/no-blueprints-found-table-empty-row/no-blueprints-found-table-empty-row";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { BlueprintTableBodyFlexWrapperWithDescriptionPopoverButton } from "../blueprint-table-body-flex-wrapper-with-description-popover-button/blueprint-table-body-flex-wrapper-with-description-popover-button";
import { BlueprintTableBodyFlexWrapperWithVerifiedIcon } from "../blueprint-table-body-flex-wrapper-with-verified-icon/blueprint-table-body-flex-wrapper-with-verified-icon";
import styles from "./blueprint-table-body.module.scss";
import { TimezoneDate } from "@src/components/atoms/timezone-date/timezone-date";

const cssClassName = "blueprint-table-body";

export interface PopoverPositionObjectTypes {
  x: number;
  y: number;
}
interface BlueprintTableBodyPropTypes {
  blueprintArray: BlueprintsArrayObjectTypes[];
  activeBlueprint: BlueprintsArrayObjectTypes;
  popoverPositionCallback: (coordinates: PopoverPositionObjectTypes) => void;
  activePopoverCallback: (blueprint: BlueprintsArrayObjectTypes) => void;
  activeBlueprintCallback: (blueprint: BlueprintsArrayObjectTypes) => void;
}

export const BlueprintTableBody = forwardRef(
  (
    {
      blueprintArray,
      activeBlueprint,
      popoverPositionCallback,
      activePopoverCallback,
      activeBlueprintCallback,
    }: BlueprintTableBodyPropTypes,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <tbody className={styles[`${cssClassName}`]}>
        {blueprintArray.length > 0 ? (
          blueprintArray.map((blueprint) => (
            <tr
              className={cn(styles[`${cssClassName}__table-body-row`], {
                [styles[`${cssClassName}__table-body-row--active`]]:
                  activeBlueprint && activeBlueprint.id === blueprint.id,
              })}
              key={blueprint.id}
              onClick={() => activeBlueprintCallback(blueprint)}
            >
              <td className={styles[`${cssClassName}__table-body-cell`]}>
                <BlueprintTableBodyFlexWrapperWithDescriptionPopoverButton
                  ref={ref}
                  blueprint={blueprint}
                  popoverPositionCallback={popoverPositionCallback}
                  activePopoverCallback={activePopoverCallback}
                  activeBlueprintCallback={activeBlueprintCallback}
                />
              </td>

              <td className={styles[`${cssClassName}__table-body-cell`]}>
                {blueprint.updated_at ? (
                  <TimezoneDate date={new Date(blueprint.updated_at)} />
                ) : (
                  "-"
                )}
              </td>
              <td className={styles[`${cssClassName}__table-body-cell`]}>
                {blueprint.author}
              </td>
              <td className={styles[`${cssClassName}__table-body-cell`]}>
                <BlueprintTableBodyFlexWrapperWithVerifiedIcon
                  blueprint={blueprint}
                />
              </td>
            </tr>
          ))
        ) : (
          <NoBlueprintsFoundTableEmptyRow />
        )}
      </tbody>
    );
  },
);

BlueprintTableBody.displayName = "BlueprintTableBody";
